import styled from 'styled-components';
export default styled.table.withConfig({
  displayName: "Table",
  componentId: "sc-1bl6tp-0"
})(["max-width:100%;text-align:left;width:100%;"]);